import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { call, put, delay, select } from 'redux-saga/effects';
import { reloadStashStream } from '../actions';
import { getCurrentFolderId, getCurrentSubfolderId } from '../selectors';
import { uploadFile } from '../../redux/uploads/actions';
export function* uploadFileHandler(payload) {
    yield put(uploadFile(_object_spread_props(_object_spread({}, payload), {
        onSuccess: function*() {
            yield delay(1000); // wait arbitrary 1s for stash to update
            yield put(reloadStashStream());
        }
    })));
}
function* uploadFileSaga({ payload }) {
    const folderId = yield select(getCurrentFolderId);
    const subfolderId = yield select(getCurrentSubfolderId);
    var _payload_folderId, _ref;
    yield call(uploadFileHandler, _object_spread_props(_object_spread({}, payload), {
        folderId: (_ref = (_payload_folderId = payload.folderId) !== null && _payload_folderId !== void 0 ? _payload_folderId : subfolderId) !== null && _ref !== void 0 ? _ref : folderId
    }));
}
export default uploadFileSaga;

//# sourceMappingURL=uploadFile.js.map